import { ArrowUpRight, AudioLines, Instagram } from "lucide-react";
import { tour } from "../lib/tour";

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="shell footer-top">
        <a href="#home" className="wordmark">
          <AudioLines aria-hidden="true" />
          <span><strong>School of Rock</strong><small>Lakewood Ranch / House Band</small></span>
        </a>
        <a className="text-link" href={tour.instagramUrl} target="_blank" rel="noopener noreferrer">
          <Instagram aria-hidden="true" /> Follow the band <ArrowUpRight aria-hidden="true" />
        </a>
      </div>
      <div className="shell footer-bottom">
        <p>A fan-made site supporting the House Band. Not affiliated with School of Rock.</p>
        <p>Made by <a href="https://ag11.dev" target="_blank" rel="noopener noreferrer">ag11.dev</a></p>
      </div>
    </footer>
  );
}
